export default {
  data() {
    return {
      search: '',
      focus: false,
    };
  },
  methods: {
    /**
     * Send search
     */
    sendSearch() {
      if (this.search.length >= 3) {
        this.$emit('sendSearch', this.search);
      }
    },

    /**
     * Reset search
     */
    reset() {
      this.search = '';
      this.$emit('resetSearch');
    },
  },
};
